// Artera Home — Sunwashed Serenity theme JS
// Mobile-first. Drawer, sticky PDP, scroll reveal, variant picker, AJAX cart.

(function () {
  'use strict';

  // ---- Accessibility: polite announce helper for screen readers ----
  // Wire up once — polite live region lives in layout/theme.liquid
  window.arteraAnnounce = function(message) {
    const el = document.getElementById('a11y-announce');
    if (!el) return;
    // Clear then set — some screen readers ignore unchanged text
    el.textContent = '';
    setTimeout(() => { el.textContent = message; }, 50);
  };

  // ---- Inline search overlay + predictive results ----
  (function initSearch() {
    const overlay = document.querySelector('[data-search-overlay]');
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    if (!overlay || !input) return;

    function open() {
      overlay.hidden = false;
      document.querySelectorAll('[data-search-toggle]').forEach(b => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => input.focus(), 50);
    }
    function close() {
      overlay.hidden = true;
      if (results) { results.hidden = true; results.innerHTML = ''; }
      input.value = '';
      document.querySelectorAll('[data-search-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-toggle]')) {
        e.preventDefault();
        overlay.hidden ? open() : close();
        return;
      }
      if (e.target.closest('[data-search-close]')) {
        close();
        return;
      }
      // Click outside the overlay closes it
      if (!overlay.hidden && !e.target.closest('[data-search-overlay]') && !e.target.closest('[data-search-toggle]')) {
        close();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !overlay.hidden) close();
    });

    // Predictive search — debounced
    let timer = null;
    let lastQuery = '';
    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      clearTimeout(timer);
      if (q.length < 2) {
        if (results) { results.hidden = true; results.innerHTML = ''; }
        return;
      }
      timer = setTimeout(() => fetchResults(q), 220);
    });

    async function fetchResults(q) {
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        const r = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!r.ok) throw new Error('search failed');
        const data = await r.json();
        renderResults(q, data);
      } catch (err) {
        if (results) {
          results.hidden = false;
          results.innerHTML = '<p class="search-result__empty">Search unavailable. Try again.</p>';
        }
      }
    }

    function renderResults(q, data) {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!results) return;
      if (products.length === 0) {
        results.hidden = false;
        results.innerHTML = '<p class="search-result__empty">No results for "' + escapeHtml(q) + '". Try a different word.</p>';
        return;
      }
      const html = products.map(p => {
        /* suggest.json: image là chuỗi URL; featured_image có thể là object {url} */
        let img = '';
        if (typeof p.image === 'string') img = p.image;
        else if (p.image && p.image.url) img = p.image.url;
        else if (typeof p.featured_image === 'string') img = p.featured_image;
        else if (p.featured_image && p.featured_image.url) img = p.featured_image.url;
        else if (p.featured_image && p.featured_image.src) img = p.featured_image.src;
        else if (p.image && p.image.src) img = p.image.src;
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        const price = p.price || (p.variants && p.variants[0] && p.variants[0].price) || '';
        const title = (p.title || '').replace(/^Boho\s+/i,'').replace(/^Rustic\s+/i,'Warm ').replace(/^Exotic\s+/i,'Distinctive ');
        return '<a href="' + p.url + '" class="search-result">'
          + (img ? '<span class="search-result__img" style="background-image:url(\'' + img + '\')"></span>' : '<span class="search-result__img"></span>')
          + '<span class="search-result__body">'
            + '<h4 class="search-result__title">' + escapeHtml(title) + '</h4>'
            + (p.product_type ? '<span class="search-result__type">' + escapeHtml(p.product_type) + '</span>' : '')
          + '</span>'
          + (price ? '<span class="search-result__price">' + formatPrice(price) + '</span>' : '')
          + '</a>';
      }).join('');
      results.hidden = false;
      results.innerHTML = html + '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-result__see-all">See all results for "' + escapeHtml(q) + '" →</a>';
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
    }
    function formatPrice(p) {
      if (typeof p === 'string' && p.includes('$')) return p;
      /* suggest.json trả giá dạng dollar: "780.00" */
      const n = parseFloat(p);
      if (isNaN(n)) return '';
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    }
  })();

  // ---- Sticky filterbar shadow on scroll ----
  // Toggle .is-stuck when sticky bar leaves natural position so we can
  // add a subtle shadow indicating it's now floating over content.
  (function initStickyFilterShadow() {
    const fb = document.querySelector('.filterbar-v2');
    if (!fb) return;
    // Use a sentinel element placed above the filterbar — when sentinel
    // leaves viewport, filterbar is stuck.
    const sentinel = document.createElement('div');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.height = '1px';
    sentinel.style.width = '1px';
    if (fb.parentElement) fb.parentElement.insertBefore(sentinel, fb);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            fb.classList.toggle('is-stuck', !e.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      io.observe(sentinel);
    }
  })();

  // =============================================================
  // FILTER PIN — production
  // Pin filter to top: 0 of viewport when scrolled past natural position.
  // Header sticky is unreliable in Shopify customizer iframe so we don't
  // depend on it — filter sits flush at top of viewport regardless.
  // CSS gives the fixed filter z-index 60 (above header z-50) so it
  // visually covers any sticky header in the same space.
  // =============================================================
  const PIN_OFFSET = 0;     // pin at very top of viewport
  let _filterbarRafScheduled = false;
  let _filterbarPlaceholder  = null;

  function ensurePlaceholder(filterbar) {
    let p = filterbar.nextElementSibling;
    if (!p || !p.classList || !p.classList.contains('filterbar-v2-placeholder')) {
      p = document.createElement('div');
      p.className = 'filterbar-v2-placeholder';
      p.setAttribute('aria-hidden', 'true');
      p.style.display = 'none';
      filterbar.parentNode.insertBefore(p, filterbar.nextSibling);
    }
    return p;
  }

  function updateFilterbarFixed() {
    _filterbarRafScheduled = false;
    const filterbar = document.querySelector('[data-filterbar]');
    const sentinel  = document.querySelector('[data-filterbar-sentinel]');
    if (!filterbar || !sentinel) return;

    if (!_filterbarPlaceholder || !_filterbarPlaceholder.isConnected) {
      _filterbarPlaceholder = ensurePlaceholder(filterbar);
    }

    const sentinelTop   = sentinel.getBoundingClientRect().top;
    const shouldBeFixed = sentinelTop <= PIN_OFFSET;
    const isFixed       = filterbar.classList.contains('is-fixed');

    if (shouldBeFixed && !isFixed) {
      _filterbarPlaceholder.style.height = filterbar.offsetHeight + 'px';
      _filterbarPlaceholder.style.display = 'block';
      filterbar.classList.add('is-fixed');
      filterbar.style.top = PIN_OFFSET + 'px';
    } else if (!shouldBeFixed && isFixed) {
      filterbar.classList.remove('is-fixed');
      filterbar.style.top = '';
      _filterbarPlaceholder.style.display = 'none';
    }
  }

  function onFilterbarScroll() {
    if (_filterbarRafScheduled) return;
    _filterbarRafScheduled = true;
    requestAnimationFrame(updateFilterbarFixed);
  }

  window.addEventListener('scroll',  onFilterbarScroll, { passive: true });
  window.addEventListener('resize',  onFilterbarScroll, { passive: true });
  document.addEventListener('scroll', onFilterbarScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', updateFilterbarFixed);
  document.addEventListener('shopify:section:load', updateFilterbarFixed);
  if (document.readyState !== 'loading') updateFilterbarFixed();

  // ---- Collection filterbar v2: dropdown toggles + view density ----
  // Event delegation pattern — survives Shopify section re-renders in
  // Customize editor (where sections get swapped in/out without page reload).
  (function initFilterbar() {
    // ---- McGee mobile filter drawer ----
    // On mobile, .filterbar-v2__left becomes a slide-in drawer.
    // Triggered by [data-filter-drawer-open]. Closed by [data-filter-drawer-close],
    // backdrop click, or Escape key.
    function openFilterDrawer() {
      const drawer = document.querySelector('[data-filter-drawer]');
      const backdrop = document.querySelector('.filter-drawer-backdrop');
      const trigger = document.querySelector('[data-filter-drawer-open]');
      if (!drawer) return;
      drawer.classList.add('is-open');
      if (backdrop) {
        backdrop.hidden = false;
        // next frame so transition fires
        requestAnimationFrame(() => backdrop.setAttribute('data-open', 'true'));
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('has-filter-drawer-open');
    }
    function closeFilterDrawer() {
      const drawer = document.querySelector('[data-filter-drawer]');
      const backdrop = document.querySelector('.filter-drawer-backdrop');
      const trigger = document.querySelector('[data-filter-drawer-open]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (backdrop) {
        backdrop.removeAttribute('data-open');
        // hide after transition completes
        setTimeout(() => { if (!drawer.classList.contains('is-open')) backdrop.hidden = true; }, 360);
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('has-filter-drawer-open');
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-filter-drawer-open]')) {
        e.preventDefault();
        openFilterDrawer();
        return;
      }
      if (e.target.closest('[data-filter-drawer-close]')) {
        // Don't preventDefault for links — let them navigate. Close after.
        if (!e.target.closest('a')) e.preventDefault();
        closeFilterDrawer();
        return;
      }
    });

    // Helper — sync the horizontal-scroll container's overflow so an open
    // dropdown isn't clipped. Desktop only — mobile uses drawer pattern.
    function syncScrollOverflow() {
      const left = document.querySelector('.filterbar-v2__left');
      if (!left) return;
      // On mobile (drawer mode), don't touch overflow
      if (window.matchMedia('(max-width: 699px)').matches) return;
      const anyOpen = !!document.querySelector('[data-filter-dd-toggle][aria-expanded="true"]');
      left.classList.toggle('has-open-dd', anyOpen);
    }

    function closeAllDropdowns(except) {
      document.querySelectorAll('[data-filter-dd]').forEach(dd => {
        if (dd === except) return;
        const toggle = dd.querySelector('[data-filter-dd-toggle]');
        const menu = dd.querySelector('[data-filter-dd-menu]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (menu) menu.hidden = true;
      });
      syncScrollOverflow();
    }

    // Single delegated click handler for whole document
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-filter-dd-toggle]');
      if (toggle) {
        e.stopPropagation();
        e.preventDefault();
        const dd = toggle.closest('[data-filter-dd]');
        const menu = dd && dd.querySelector('[data-filter-dd-menu]');
        if (!menu) return;
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAllDropdowns(dd);
        if (isOpen) {
          toggle.setAttribute('aria-expanded', 'false');
          menu.hidden = true;
        } else {
          toggle.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        }
        syncScrollOverflow();
        return;
      }
      // Click outside any dropdown closes all
      if (!e.target.closest('[data-filter-dd]')) closeAllDropdowns(null);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeAllDropdowns(null);
        // Also close mobile drawer if open
        const drawer = document.querySelector('[data-filter-drawer]');
        if (drawer && drawer.classList.contains('is-open')) closeFilterDrawer();
      }
    });

    // View density toggle (3col / 2col) — persists via cookie
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-view-toggle]');
      if (!btn) return;
      const v = btn.dataset.viewToggle;
      const grid = document.querySelector('[data-coll-grid]');
      if (!grid) return;
      grid.classList.toggle('view--2col', v === '2col');
      grid.classList.toggle('view--3col', v === '3col');
      document.querySelectorAll('[data-view-toggle]').forEach(b => {
        const active = b.dataset.viewToggle === v;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      try {
        document.cookie = 'artera_view=' + v + '; path=/; max-age=2592000; samesite=lax';
      } catch(err) {}
    });

    // Restore saved view density on page load
    function restoreView() {
      let saved = '';
      try {
        const m = document.cookie.split('; ').find(r => r.indexOf('artera_view=') === 0);
        if (m) saved = m.split('=')[1];
      } catch(e) {}
      if (saved !== '2col') return;
      const grid = document.querySelector('[data-coll-grid]');
      if (!grid) return;
      grid.classList.add('view--2col');
      document.querySelectorAll('[data-view-toggle]').forEach(b => {
        const active = b.dataset.viewToggle === '2col';
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    restoreView();
    // Re-apply when Shopify Customize swaps sections
    document.addEventListener('shopify:section:load', restoreView);

    // ---- Price range slider (dual-handle) ----
    function initPriceSliders() {
      document.querySelectorAll('[data-price-slider]').forEach((slider) => {
        if (slider.dataset.bound === '1') return;
        slider.dataset.bound = '1';
        const minInput = slider.querySelector('[data-price-input-min]');
        const maxInput = slider.querySelector('[data-price-input-max]');
        const minLabel = slider.querySelector('[data-price-min-label]');
        const maxLabel = slider.querySelector('[data-price-max-label]');
        const fill = slider.querySelector('[data-price-fill]');
        const applyBtn = slider.querySelector('[data-price-apply]');
        if (!minInput || !maxInput) return;
        const lo = parseInt(slider.dataset.min, 10) || 0;
        const hi = parseInt(slider.dataset.max, 10) || 1000;
        const baseUrl = slider.dataset.baseUrl || '';
        const otherParams = (slider.dataset.otherParams || '').replace(/&amp;/g, '&');

        function paint() {
          let a = parseInt(minInput.value, 10);
          let b = parseInt(maxInput.value, 10);
          // Prevent crossover
          if (a > b - 10) { if (this === maxInput) { a = b - 10; minInput.value = a; } else { b = a + 10; maxInput.value = b; } }
          if (minLabel) minLabel.textContent = minInput.value;
          if (maxLabel) maxLabel.textContent = maxInput.value;
          if (fill) {
            const left = ((a - lo) / (hi - lo)) * 100;
            const right = ((b - lo) / (hi - lo)) * 100;
            fill.style.left = left + '%';
            fill.style.width = (right - left) + '%';
          }
        }
        minInput.addEventListener('input', paint);
        maxInput.addEventListener('input', paint);
        paint();

        function apply() {
          const a = parseInt(minInput.value, 10);
          const b = parseInt(maxInput.value, 10);
          let params = otherParams || '';
          // Strip any existing price params from carried-over filters
          params = params.replace(/&?filter\.v\.price\.(gte|lte)=\d+/g, '');
          let qs = '';
          if (a > lo) qs += '&filter.v.price.gte=' + a;
          if (b < hi) qs += '&filter.v.price.lte=' + b;
          qs += params;
          qs = qs.replace(/^&/, '');
          window.location.href = baseUrl + (qs ? '?' + qs : '');
        }
        if (applyBtn) applyBtn.addEventListener('click', apply);
      });
    }
    initPriceSliders();
    document.addEventListener('shopify:section:load', initPriceSliders);
  })();

  // ---- Nav scroll shadow ----
  const nav = document.querySelector('.nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ---- Mobile drawer ----
  const drawer = document.querySelector('[data-drawer]');
  const openers = document.querySelectorAll('[data-drawer-open]');
  const closer = document.querySelector('[data-drawer-close]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  };
  openers.forEach(o => o.addEventListener('click', openDrawer));
  if (closer) closer.addEventListener('click', closeDrawer);
  if (drawer) drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));
  window.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // ---- Scroll reveal ----
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-visible'));
  }

  // ---- Hero Ken Burns trigger ----
  setTimeout(() => {
    document.querySelectorAll('.hero__media').forEach(m => m.classList.add('active'));
  }, 50);

  // ---- PDP Gallery — scroll-snap carousel with thumb click + dot sync ----
  const pdpMain = document.querySelector('.pdp__main[data-pdp-main]');
  if (pdpMain) {
    const slides = Array.from(pdpMain.querySelectorAll('.pdp__slide'));
    const thumbs = Array.from(document.querySelectorAll('.pdp__thumbs .pdp__thumb'));
    const dots = Array.from(document.querySelectorAll('.pdp__dots .pdp__dot'));

    function setActive(index) {
      thumbs.forEach((t, i) => {
        const is = i === index;
        t.classList.toggle('active', is);
        t.setAttribute('aria-selected', is ? 'true' : 'false');
      });
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
    }

    // Click thumb → scroll main to slide
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        const slide = slides[i];
        if (slide) {
          pdpMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        setActive(i);
      });
    });

    // Tap dot → scroll main to slide (mobile carousel navigation).
    // Dots are <span> with a 44×44 invisible ::before tap area — clickable.
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const slide = slides[i];
        if (slide) {
          pdpMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        setActive(i);
      });
      dot.style.cursor = 'pointer';
    });

    // Prev / Next arrow buttons
    function currentIndex() {
      // Find the slide most visible in viewport of pdpMain
      const scrollLeft = pdpMain.scrollLeft;
      const mainWidth = pdpMain.clientWidth;
      let best = 0, bestDiff = Infinity;
      slides.forEach((s, i) => {
        const diff = Math.abs(s.offsetLeft - scrollLeft);
        if (diff < bestDiff) { bestDiff = diff; best = i; }
      });
      return best;
    }
    document.querySelectorAll('[data-pdp-nav]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const direction = btn.dataset.pdpNav;
        const current = currentIndex();
        let next = direction === 'next' ? current + 1 : current - 1;
        // Wrap around
        if (next < 0) next = slides.length - 1;
        if (next >= slides.length) next = 0;
        const slide = slides[next];
        if (slide) {
          pdpMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActive(next);
        }
      });
    });

    // Observe main scroll to update active thumb/dot on swipe
    if ('IntersectionObserver' in window && slides.length > 1) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            const idx = slides.indexOf(entry.target);
            if (idx >= 0) setActive(idx);
          }
        });
      }, { root: pdpMain, threshold: [0.6, 0.9] });
      slides.forEach(s => io.observe(s));
    }

    // Image zoom — desktop hover pan + mobile tap-to-fullscreen lightbox
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isTouch = window.matchMedia('(hover: none)').matches;

    slides.forEach(slide => {
      const img = slide.querySelector('.pdp__slide-img, img');
      if (!img) return;

      // Desktop: move image proportionally to cursor
      if (!isTouch && !prefersReducedMotion) {
        slide.addEventListener('mousemove', (e) => {
          const rect = slide.getBoundingClientRect();
          const xPct = ((e.clientX - rect.left) / rect.width) * 100;
          const yPct = ((e.clientY - rect.top) / rect.height) * 100;
          slide.style.setProperty('--zoom-x', xPct + '%');
          slide.style.setProperty('--zoom-y', yPct + '%');
          slide.style.setProperty('--zoom-scale', '1.8');
        });
        slide.addEventListener('mouseleave', () => {
          slide.style.setProperty('--zoom-scale', '1');
        });
      }

      // Click / tap → open fullscreen lightbox for pinch-zoom
      slide.addEventListener('click', (e) => {
        // Don't open lightbox if clicking a nav arrow
        if (e.target.closest('.pdp__nav')) return;
        openLightbox(img.src || img.currentSrc);
      });
    });

    // Lightbox implementation
    function openLightbox(src) {
      if (!src) return;
      let lb = document.querySelector('.pdp-lightbox');
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'pdp-lightbox';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', 'Product image');
        lb.innerHTML =
          '<button type="button" class="pdp-lightbox__close" aria-label="Close">' +
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 6l12 12M18 6l-12 12"/></svg>' +
          '</button>' +
          '<img class="pdp-lightbox__img" alt="">' +
          '<div class="pdp-lightbox__hint">Pinch or scroll to zoom</div>';
        document.body.appendChild(lb);

        lb.querySelector('.pdp-lightbox__close').addEventListener('click', closeLightbox);
        lb.addEventListener('click', (e) => {
          if (e.target === lb) closeLightbox();
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && lb.getAttribute('data-open') === 'true') closeLightbox();
        });

        // Desktop wheel zoom
        const lbImg = lb.querySelector('.pdp-lightbox__img');
        let scale = 1;
        lb.addEventListener('wheel', (e) => {
          if (lb.getAttribute('data-open') !== 'true') return;
          e.preventDefault();
          scale += e.deltaY * -0.002;
          scale = Math.min(Math.max(1, scale), 4);
          lbImg.style.transform = 'scale(' + scale + ')';
        }, { passive: false });

        // Mobile pinch zoom
        let initialDist = 0;
        let initialScale = 1;
        lb.addEventListener('touchstart', (e) => {
          if (e.touches.length === 2) {
            initialDist = Math.hypot(
              e.touches[0].clientX - e.touches[1].clientX,
              e.touches[0].clientY - e.touches[1].clientY
            );
            initialScale = scale;
          }
        }, { passive: true });
        lb.addEventListener('touchmove', (e) => {
          if (e.touches.length === 2 && initialDist > 0) {
            e.preventDefault();
            const dist = Math.hypot(
              e.touches[0].clientX - e.touches[1].clientX,
              e.touches[0].clientY - e.touches[1].clientY
            );
            scale = Math.min(Math.max(1, initialScale * (dist / initialDist)), 4);
            lbImg.style.transform = 'scale(' + scale + ')';
          }
        }, { passive: false });

        lb._resetZoom = () => { scale = 1; lbImg.style.transform = 'scale(1)'; };
      }

      const lbImg = lb.querySelector('.pdp-lightbox__img');
      lbImg.src = src;
      lb.setAttribute('data-open', 'true');
      document.body.classList.add('pdp-lightbox-open');
      if (lb._resetZoom) lb._resetZoom();
    }

    function closeLightbox() {
      const lb = document.querySelector('.pdp-lightbox');
      if (!lb) return;
      lb.setAttribute('data-open', 'false');
      document.body.classList.remove('pdp-lightbox-open');
      if (lb._resetZoom) lb._resetZoom();
    }

    // Expose a small API so the variant picker can drive the gallery
    // when a variant's featured_media differs from the currently-visible slide.
    window.ARTERA_PDP_GALLERY = {
      scrollToIndex: function(index) {
        if (index < 0 || index >= slides.length) return;
        const slide = slides[index];
        if (!slide) return;
        pdpMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(index);
      },
      scrollToMediaId: function(mediaId) {
        if (!mediaId) return;
        // slides are rendered in product.media order; match by data-slide-index
        // but the underlying media id lives on window.ARTERA_PRODUCT.media.
        const media = (window.ARTERA_PRODUCT && window.ARTERA_PRODUCT.media) || [];
        const mediaIndex = media.findIndex(m => String(m.id) === String(mediaId));
        if (mediaIndex >= 0) this.scrollToIndex(mediaIndex);
      }
    };
  }

  // ---- Variant picker (Shopify product form) ----
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const variantInput = productForm.querySelector('input[name="id"]');
    const priceEl = document.querySelector('.pdp__price');
    const submitBtn = productForm.querySelector('[data-pdp-add]');

    const selectedOptions = {};
    productForm.querySelectorAll('.pdp__options').forEach(group => {
      const opts = group.querySelectorAll('.pdp__option, .pdp__swatch');
      opts.forEach(opt => {
        if (opt.classList.contains('selected')) {
          selectedOptions[opt.dataset.optionPosition] = opt.dataset.optionValue;
        }
        opt.addEventListener('click', () => {
          opts.forEach(o => o.classList.remove('selected'));
          opt.classList.add('selected');
          const pos = opt.dataset.optionPosition;
          const val = opt.dataset.optionValue;
          selectedOptions[pos] = val;
          // Update "selected value" label next to swatch group heading
          const label = document.querySelector(`[data-swatch-value-for="${pos}"]`);
          if (label) label.textContent = val;
          updateVariant();
        });
      });
    });

    // B — Dropdown variant option support (>6 values → <select>)
    productForm.querySelectorAll('.pdp__option-select').forEach(selectEl => {
      const pos = selectEl.dataset.optionPosition;
      selectedOptions[pos] = selectEl.value;
      selectEl.addEventListener('change', () => {
        selectedOptions[pos] = selectEl.value;
        updateVariant();
      });
    });

    async function updateVariant() {
      // Build option value array and call Shopify's product JSON to find variant
      if (!window.ARTERA_PRODUCT) return;
      const product = window.ARTERA_PRODUCT;
      const match = product.variants.find(v =>
        (!selectedOptions['1'] || v.option1 === selectedOptions['1']) &&
        (!selectedOptions['2'] || v.option2 === selectedOptions['2']) &&
        (!selectedOptions['3'] || v.option3 === selectedOptions['3'])
      );
      if (!match) return;
      if (variantInput) variantInput.value = match.id;

      // C — Update price in both hero location + legacy .pdp__price + submit button
      const heroPrice = document.querySelector('[data-pdp-price-display]');
      if (heroPrice) heroPrice.textContent = formatMoney(match.price);
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (submitBtn) {
        // ATC has structured inner spans now (.pdp__atc-label + .pdp__atc-price).
        // Update spans to preserve serif italic price styling.
        const atcLabel = submitBtn.querySelector('.pdp__atc-label');
        const atcPrice = submitBtn.querySelector('[data-pdp-atc-price]');
        if (match.available) {
          submitBtn.disabled = false;
          if (atcLabel) atcLabel.textContent = 'Add to cart';
          if (atcPrice) {
            atcPrice.textContent = formatMoney(match.price);
            atcPrice.style.display = '';
          }
          // Legacy fallback if old single-span structure
          if (!atcLabel && !atcPrice) submitBtn.textContent = `Add to cart — ${formatMoney(match.price)}`;
        } else {
          submitBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Sold out';
          if (atcPrice) atcPrice.style.display = 'none';
          if (!atcLabel) submitBtn.textContent = 'Sold out';
        }
      }

      // A — Update dimensions badge for per-variant dimensions (Cấp 2 setup).
      // Variant metafield map exposed via window.ARTERA_VARIANT_META (see section).
      const dimEl = document.querySelector('[data-pdp-dimensions-text]');
      const dimWrap = document.querySelector('[data-pdp-dimensions]');
      if (dimEl && window.ARTERA_VARIANT_META) {
        const vm = window.ARTERA_VARIANT_META[match.id];
        const vDim = vm && vm.dimensions;
        if (vDim && vDim.length > 0) {
          dimEl.textContent = vDim;
          if (dimWrap) dimWrap.style.display = '';
        }
        // If variant has no dimensions, keep showing product-level fallback (already rendered)
      }

      // Gallery — scroll to variant's featured_media if one is linked.
      // When merchandiser uploads a variant-specific image in Shopify, that
      // media gets a variant association: product.media[i].id matches
      // variant.featured_media.id. Without this, clicking "Set of 3 Floral"
      // while the gallery is still on "Set of 4 Geometric" shows the wrong image.
      if (window.ARTERA_PDP_GALLERY) {
        const variantMediaId =
          (match.featured_media && match.featured_media.id) ||
          match.featured_media_id ||
          (match.featured_image && match.featured_image.id);
        if (variantMediaId) {
          window.ARTERA_PDP_GALLERY.scrollToMediaId(variantMediaId);
        }
      }

      // E — Update stock hint text when variant changes
      const stockHint = document.querySelector('[data-pdp-stock]');
      const stockTxt = document.querySelector('[data-pdp-stock-text]');
      if (stockHint && stockTxt) {
        const qty = match.inventory_quantity;
        const threshold = parseInt(stockHint.dataset.threshold || '10', 10);
        if (match.available && qty > 0 && qty <= threshold) {
          stockHint.style.display = '';
          stockTxt.textContent = qty === 1
            ? 'The last one in this batch'
            : `${qty} remaining in this batch`;
        } else {
          stockHint.style.display = 'none';
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    // AJAX add to cart
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!submitBtn) return;
      submitBtn.disabled = true;
      const originalText = submitBtn.textContent;
      submitBtn.dataset.originalText = originalText;
      submitBtn.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: new URLSearchParams(new FormData(productForm))
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || 'Cart error');
        submitBtn.textContent = 'Added ✓';
        // Announce to screen readers
        if (window.arteraAnnounce) {
          window.arteraAnnounce('Added to cart — ' + (window.ARTERA_PRODUCT && window.ARTERA_PRODUCT.title || 'item'));
        }
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1200);

        // Refresh cart drawer contents + count, then open it
        if (typeof window.refreshCartDrawer === 'function') {
          await window.refreshCartDrawer();
        }
        // Get latest cart for accurate count
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          if (typeof cart.item_count === 'number') {
            document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
          }
        } catch (_) {}
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
      } catch (err) {
        submitBtn.textContent = 'Try again';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 1600);
      }
    });
  }

  // ---- PDP info tabs (Shipping / Returns / Care) ----
  document.querySelectorAll('[data-info-tabs]').forEach(scope => {
    const btns = scope.querySelectorAll('.info-tabs__btn');
    const panels = scope.querySelectorAll('.info-tabs__panel');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        btns.forEach(b => {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === target));
      });
    });
  });

  // ---- PDP quantity stepper — syncs with hidden form input named "quantity" ----
  document.querySelectorAll('[data-pdp-qty]').forEach(qty => {
    const input = qty.querySelector('[data-pdp-qty-input]');
    const minus = qty.querySelector('[data-pdp-qty-minus]');
    const plus  = qty.querySelector('[data-pdp-qty-plus]');
    if (!input) return;
    const min = parseInt(input.min || 1);
    const max = parseInt(input.max || 99);
    if (minus) minus.addEventListener('click', () => {
      input.value = Math.max(min, parseInt(input.value || min) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', () => {
      input.value = Math.min(max, parseInt(input.value || min) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('blur', () => {
      let v = parseInt(input.value);
      if (isNaN(v) || v < min) v = min;
      if (v > max) v = max;
      input.value = v;
    });
  });

  // ---- Cart count updates ----
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
    // Toggle .nav__cart--empty class for hide-when-zero pattern
    document.querySelectorAll('.nav__cart').forEach(el => {
      el.classList.toggle('nav__cart--empty', count === 0 || count === '0');
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  // ---- PDP: mobile sticky bottom bar ----
  const stickyBar = document.querySelector('.pdp__sticky');
  const primaryAdd = document.querySelector('.pdp__add');
  if (stickyBar && primaryAdd) {
    const onScroll = () => {
      const r = primaryAdd.getBoundingClientRect();
      const offscreen = r.bottom < 0 || r.top > window.innerHeight;
      stickyBar.classList.toggle('show', offscreen);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  // ---- Cart Drawer ----
  const cartDrawer = document.getElementById('CartDrawer');
  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  // Expose globally for AJAX handlers
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  // Cart icon click → open drawer
  document.querySelectorAll('[data-cart-open]').forEach(a => {
    a.addEventListener('click', e => {
      if (cartDrawer) { e.preventDefault(); openCartDrawer(); }
    });
  });

  // Close button / backdrop → close drawer
  document.addEventListener('click', e => {
    const closer = e.target.closest('[data-cart-drawer-close]');
    if (closer) {
      /* Nếu là link thật (vd "Open the collection") thì đóng drawer
         và ĐỂ trình duyệt điều hướng bình thường */
      const href = closer.getAttribute && closer.getAttribute('href');
      if (href && href !== '#') { closeCartDrawer(); return; }
      e.preventDefault();
      closeCartDrawer();
    }
  });

  // ESC to close
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) {
      closeCartDrawer();
    }
  });

  // ---- Cart line updates (quantity +/- and remove) ----
  async function changeCartLine(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || 'Cart error');
      await refreshCartDrawer();
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error('[Artera] Cart change failed', err);
    }
  }

  // Fetch fresh cart drawer body HTML via Shopify sections API
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-live');
      const data = await res.json();
      const body = document.querySelector('[data-cart-drawer-body]');
      if (body && data['cart-live']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-live'];
        const newBody = tmp.querySelector('[data-cart-drawer-body]') || tmp.firstElementChild;
        if (newBody) body.innerHTML = newBody.innerHTML;
      } else {
        // Fallback: parse cart page and extract drawer body
        const html = await (await fetch('/cart')).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newBody = doc.querySelector('[data-cart-drawer-body]');
        if (newBody && body) body.innerHTML = newBody.innerHTML;
      }
      // Stark 28/09: keep drawer header count in sync after any refresh
      try {
        const c = await (await fetch('/cart.js')).json();
        if (typeof c.item_count === 'number') updateCartCount(c.item_count);
      } catch (_) {}
    } catch (err) {
      console.error('[Artera] Cart refresh failed', err);
    }
  }
  window.refreshCartDrawer = refreshCartDrawer;

  // Delegate quantity buttons (work on dynamically loaded content)
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.dataset.qtyChange;
    const setTo = btn.dataset.qtySet;
    const delta = parseInt(btn.dataset.qtyDelta || '0', 10);

    if (setTo !== undefined) {
      changeCartLine(key, parseInt(setTo, 10));
    } else {
      const input = document.querySelector(`[data-qty-input="${key}"]`);
      const current = input ? parseInt(input.value, 10) : 1;
      changeCartLine(key, Math.max(0, current + delta));
    }
  });

  // Update header cart count
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
    const countInDrawer = document.querySelector('[data-cart-drawer-count]');
    if (countInDrawer) countInDrawer.textContent = count;
    const labelInDrawer = document.querySelector('[data-cart-drawer-count-label]');
    if (labelInDrawer) labelInDrawer.textContent = count === 1 ? 'piece' : 'pieces';
  }

  // Filter bar is rendered inline (no sticky) — simpler, works everywhere,
  // matches editorial convention of Kinfolk/Parachute/Serena & Lily.

  // ---- Quick Add (product card hover button) ----
  // Adds a single-variant product directly from the grid, then opens cart drawer.
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;

    btn.classList.add('is-loading');
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams({ id: variantId, quantity: '1' })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || 'Cart error');

      btn.classList.remove('is-loading');
      btn.classList.add('is-done');

      // Refresh drawer + count, then open it
      if (typeof window.refreshCartDrawer === 'function') {
        await window.refreshCartDrawer();
      }
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        if (typeof cart.item_count === 'number') {
          document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        }
      } catch (_) {}
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      }

      setTimeout(() => { btn.classList.remove('is-done'); }, 1800);
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.textContent = 'Try again';
      setTimeout(() => {
        // restore original markup
        btn.innerHTML = '<span class="card__quickadd-label">Quick add</span>'
          + '<span class="card__quickadd-loading" aria-hidden="true">Adding…</span>'
          + '<span class="card__quickadd-done" aria-hidden="true">Added ✓</span>';
      }, 1600);
    }
  });
})();

/* ---- Companion carousel arrows (B2) ---- */
(function () {
  function initPairsRails() {
    document.querySelectorAll('[data-pairs-rail]').forEach(function (rail) {
      if (rail.dataset.bound === '1') return;
      rail.dataset.bound = '1';
      var track = rail.querySelector('[data-pairs-track]');
      var prev = rail.querySelector('[data-pairs-prev]');
      var next = rail.querySelector('[data-pairs-next]');
      if (!track) return;
      function step() { return Math.max(track.clientWidth * 0.8, 240); }
      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= maxScroll;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState !== 'loading') initPairsRails();
  else document.addEventListener('DOMContentLoaded', initPairsRails);
  document.addEventListener('shopify:section:load', initPairsRails);
})();





/* ============================================================
   STAMPED CAPTION SHORTEN — trên card: "8 Reviews" → "(8)".
   Badge do JS của Stamped bơm vào sau, nên dùng MutationObserver.
   ============================================================ */
(function () {
  function shorten(root) {
    (root || document).querySelectorAll('.card__rating .stamped-badge-caption, .card .stamped-badge-caption').forEach(function (el) {
      var m = (el.textContent || '').match(/(\d+)/);
      if (m && el.textContent.indexOf('Review') !== -1) el.textContent = '(' + m[1] + ')';
    });
  }
  shorten();
  var mo = new MutationObserver(function () { shorten(); });
  mo.observe(document.body, { childList: true, subtree: true });
  /* Ngừng theo dõi sau 10s — badge đã render xong từ lâu */
  setTimeout(function () { mo.disconnect(); shorten(); }, 10000);
})();